import Kfit from '../integrations/Kfit';

const createECard = params => Kfit.post('/v1/e_cards', params).then(res => res);

export default createECard;
